import { render, staticRenderFns } from "./LmTable.vue?vue&type=template&id=5b3fbff0&scoped=true&"
import script from "./LmTable.vue?vue&type=script&lang=js&"
export * from "./LmTable.vue?vue&type=script&lang=js&"
import style0 from "./LmTable.vue?vue&type=style&index=0&id=5b3fbff0&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b3fbff0",
  null
  
)

export default component.exports